import React, { Component } from "react";
import { Provider } from "react-redux";
import setupReduxStore from "./redux/configureStore";

class ProviderWithRouter extends Component {
  constructor(props) {
    super(props);
    this.store = setupReduxStore();
  }

  render() {
    return <Provider store={this.store}>{this.props.children}</Provider>;
  }
}

export default ProviderWithRouter;
